/** @format */

import { InjectionToken } from '@angular/core';
import { Tracer } from '@opentelemetry/api';

export const TRACER_TOKEN = new InjectionToken<Tracer>('TRACER_TOKEN');
